<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M47.1667 14L31.1108 82.1337" stroke="black" stroke-width="4"/>
<path d="M68.8333 14L60.8053 48.0669L52.7774 82.1337" stroke="black" stroke-width="4"/>
<path d="M78.4126 33.4667L28.4126 33.4667" stroke="black" stroke-width="4"/>
<path d="M71.5315 62.6669L21.5315 62.6669" stroke="black" stroke-width="4"/>
</svg>

</template>
